import { render, staticRenderFns } from "./GoodReturnForm.vue?vue&type=template&id=4d00ebfd"
import script from "./GoodReturnForm.vue?vue&type=script&lang=js"
export * from "./GoodReturnForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports